import { toast } from 'react-toastify';
import NewJobPricelistItemData from './NewJobPricelistItem';
import { NewJobQuoteItem, NewJobQuoteFenceQuestions, ItemOptionList } from './models/JobInterfaces';

interface NewJobPricelistFencingProps {
    isJobEvent: boolean;
    jobTypeId: number;
    accountTypeId: number;
    customerQuoteNotesDunny: string;
    customerInvoiceQuotedAmount: boolean;
    schedulePickup: boolean;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    truckHireRate: number;
    fenceQuestions: NewJobQuoteFenceQuestions;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    customerChargeFuelSurcharge: boolean;
    customerNewFuelInvoice: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    errors: { [key: string]: string };
    addError(errorName: string, errorMessage: string): void;
    clearError(errorName: string): void;
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateFenceQuestions(fenceQuestions: NewJobQuoteFenceQuestions): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
}

const NewJobPricelistFencingData = (props: NewJobPricelistFencingProps) => {

    const handleFenceQuestionsChange = (e: any) => {
        var existFenceExtra: any = {};
        existFenceExtra = props.fenceQuestions;
        existFenceExtra[e.target.name] = e.target.checked;

        if (e.target.name === "signageAdded") {
            props.clearError("signagePanels");
            existFenceExtra.signagePanels = 0;
        }

        props.updateFenceQuestions(existFenceExtra);
        if (props.fenceQuestions.fenceTotalMetres > 0) {
            reCalcBraceItems(props.fenceQuestions.fenceTotalMetres);
        }
    }

    const handleFenceQuestionsPanelsChange = (e: any) => {
        props.clearError(e.target.name);
        var existFenceExtra: any = {};
        existFenceExtra = props.fenceQuestions;
        existFenceExtra.signagePanels = (e.target.value * 1);

        props.updateFenceQuestions(existFenceExtra);
        if (props.fenceQuestions.fenceTotalMetres > 0) {
            reCalcBraceItems(props.fenceQuestions.fenceTotalMetres);
        }
    }

    const handleTotalMetresChange = (e: any) => {
        props.clearError("fenceTotalMetres");
        var totalMetres = e.target.value * 1;
        if (totalMetres < 0) {
            totalMetres = 0;
        }

        var existFenceExtra = props.fenceQuestions;
        existFenceExtra.fenceTotalMetres = totalMetres;

        props.updateFenceQuestions(existFenceExtra);

        //find any brace calculations that we need to change
        reCalcBraceItems(totalMetres);
    }

    const reCalcBraceItems = (totalFenceMetres: number) => {
        let quoteItems = [...props.quoteItems];
        let braceItems = quoteItems.filter(i => i.itemTypeId === 51);
        for (var i = 0; i < braceItems.length; i++) {
            var bracing = props.fenceQuestions.highWindArea && props.fenceQuestions.shadeClothAdded ? 1 : props.fenceQuestions.shadeClothAdded ? 2 : props.fenceQuestions.highWindArea ? 3 : 4;
            if (bracing > 0 && bracing < 4) {
                var qty = (totalFenceMetres / 2.4) / bracing;
                qty += props.fenceQuestions.signagePanels;  //add on extra panels with signs
                braceItems[i].quantity = Math.trunc(qty);
                braceItems[i].fenceBraceId = bracing;
                props.updateQuoteItem(braceItems[i], true);
            } else if (bracing === 4) {
                if (props.fenceQuestions.signagePanels > 0) {
                    braceItems[i].quantity = props.fenceQuestions.signagePanels;
                    braceItems[i].fenceBraceId = bracing;
                    props.updateQuoteItem(braceItems[i], true);
                } else {
                    braceItems[i].quantity = 0;
                    braceItems[i].fenceBraceId = bracing;
                    braceItems[i].initialHire = 0;
                    braceItems[i].amount = 0;
                    braceItems[i].overhireRate = "0";
                    props.updateQuoteItem(braceItems[i], false);
                }
            }
        }

        //recalc the fence item - just do first one
        let fenceItem = props.quoteItems.find(i => i.itemTypeId === 50);
        if (fenceItem) {
            fenceItem.quantity = totalFenceMetres;
            props.updateQuoteItem(fenceItem, true);
        }
    }

    const handleBraceChange = (e: any, itemIndex: number) => {
        let quoteItems = [...props.quoteItems];
        let quoteItem = quoteItems[itemIndex];

        if (props.fenceQuestions.fenceTotalMetres > 0) {
            var value = e.target.value * 1;
            quoteItem.fenceBraceId = value;

            var braceQty = calculateBraceQty(value)
            quoteItem.quantity = braceQty;

            if (itemIndex === (quoteItems.length - 1)) {
                var newItem = addBlankQuoteItem();
                props.addItem(newItem, false);
            }

            props.updateQuoteItem(quoteItem, true);
        } else {
            props.addError("fenceTotalMetres", "Enter total metres of fencing required!");
            toast.error("Enter the Total # Metres before selecting bracing!");
        }
    }

    const calculateBraceQty = (fenceBraceId: number) => {
        var qty = 0;
        //if custom we just want to add the signage panels not do a calc using total metres
        if (fenceBraceId < 4) {
            //calculate # braces required
            qty = (props.fenceQuestions.fenceTotalMetres / 2.4) / fenceBraceId;
        }
        //add on extra panels with signs
        qty += props.fenceQuestions.signagePanels;

        let braceQty = Math.trunc(qty);

        return braceQty;
    }

    const handleAreaChange = (e: any, itemIndex: number) => {
        let fenceQs = props.fenceQuestions;
        let fenceAreas = fenceQs.fenceAreas;
        let fenceItem = fenceAreas[itemIndex];
        
        if (fenceItem.id === 1 && e.target.checked) {
            //untick other boxes
            for (var i = 0; i < fenceAreas.length; i++) {
                fenceAreas[i].selected = false;
            }
        }
        fenceItem.selected = e.target.checked;

        props.updateFenceQuestions(fenceQs)
    }

    const addFenceItems = () => {
        if (validateQuestions()) {
            let quoteItems = [...props.quoteItems];
            let quoteItem = quoteItems[quoteItems.length - 1];
            let item = props.itemOptions.find(i => i.typeId === 50);

            if (quoteItem && item) {
                //add standard fencing
                quoteItem.itemId = item.id;
                quoteItem = addItemDetails(quoteItem, item.id);
                quoteItem.quantity = props.fenceQuestions.fenceTotalMetres;
                quoteItem.customHirePeriod = false;
                if (props.accountTypeId === 3 && !props.customerInvoiceQuotedAmount) {
                    quoteItem.notes = "Do not go over quoted lm without getting a new PO number";
                }
                props.updateQuoteItem(quoteItem, true);

                //check if bracing is required
                if (props.fenceQuestions.highWindArea || props.fenceQuestions.shadeClothAdded || props.fenceQuestions.signageAdded) {
                    //add brace item
                    let braceItem = props.itemOptions.find(i => i.typeId === 51);
                    if (braceItem) {
                        var newBraceItem = addBlankQuoteItem();
                        newBraceItem.itemId = braceItem.id;
                        newBraceItem = addItemDetails(newBraceItem, braceItem.id);
                        //add PO note for fencing items and PO customers
                        if (props.accountTypeId === 3 && !props.customerInvoiceQuotedAmount) {
                            newBraceItem.notes = "Do not go over quoted lm without getting a new PO number";
                        }

                        //set bracing # panels
                        var bracing = props.fenceQuestions.highWindArea && props.fenceQuestions.shadeClothAdded ? 1 : props.fenceQuestions.shadeClothAdded ? 2 : props.fenceQuestions.highWindArea ? 3 : 4;
                        newBraceItem.fenceBraceId = bracing;

                        //work out how many panels
                        var braceQty = calculateBraceQty(bracing)
                        newBraceItem.quantity = braceQty;

                        props.addItem(newBraceItem, true);
                    }
                }

                //add new item
                var newItem = addBlankQuoteItem();
                props.addItem(newItem, false);
            }
        } else {
            toast.error("Answer Fence Questions before adding Fence Items!")
        }
    }

    const addItemDetails = (item: NewJobQuoteItem, itemId: number) => {
        var itemOption = props.itemOptions.find(i => i.id === itemId);
        if (itemOption) {
            item.defaultHirePeriod = itemOption.priceListDefaultDays;
            item.installOnly = itemOption.installOnly;
            item.truck = itemOption.defaultTruckId;
            item.isEws = itemOption.isEws;
            item.itemTypeId = itemOption.typeId;
            item.productGroupId = itemOption.productGroupId;
            item.item = itemOption.name;
            item.itemDescription = itemOption.description;
            //clear any extras as other items don't have extras
            item.extras.itemId = -1;
            item.extras.quantity = 0;
            item.fenceBraceId = -1;
            item.hirePeriod = itemOption.priceListDefaultDays;
            item.extendable = itemOption.extendable;
            item.unitOfMeasure = itemOption.unitOfMeasure;
            item.invoicePeriodTypeId = itemOption.invoicePeriodTypeId;
            item.hours = 0;
            item.size = 0;
        }

        return item;
    }


    const addBlankQuoteItem = () => {
        var item: NewJobQuoteItem = {
            itemIndex: -1,
            itemId: -1,
            item: "",
            itemTypeId: -1,
            productGroupId: 0,
            itemDescription: "",
            installOnly: false,
            extendable: true,
            isEws: false,
            isWaste: false,
            isUnderground: false,
            isEvent: false,
            unitNumber: "",
            scheduleDate: "",
            onHireDate: "",
            offhireDate: "",
            pickupDate: "",
            hirePeriod: -1,
            defaultHirePeriod: 42,
            customHirePeriod: false,
            frequencyId: -1,
            locationId: -1,
            fenceBraceId: -1,
            hours: 0,
            size: 0,
            quantity: 1,
            unitOfMeasure: "",
            initialHire: 0,
            travel: 0,
            cleaning: 0,
            trench: 0,
            confinedSpace: 0,
            fuelSurcharge: 0,
            amount: 0,
            overhireRate: "0.00",
            truck: 0,
            truckDoors: -1,
            purchaseOrderNumber: "",
            purchaseOrderNumberFuel: "",
            notes: "",
            trolley: false,
            extras: {
                itemId: -1,
                quantity: 0,
                equipped: false
            },
            fencingStock: {
                panels: 0,
                blocks: 0,
                clamps: 0,
                pickets: 0,
                signs: 0,
                braces: 0
            },
            calculatedPriceNote: "",
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0,
            invoiceDescription: "",
            incStepsTravel: false,
            invoicePeriodTypeId: 1
        };

        return item;
    }

    const validateQuestions = () => {
        var isValid = true;

        //need to validate the questions before adding the fence items
        if (props.fenceQuestions.fenceTotalMetres === 0) {
            isValid = false;
            props.addError("fenceTotalMetres", "Enter total metres of fencing required!");
        }

        if (props.fenceQuestions.signageAdded && props.fenceQuestions.signagePanels <= 0) {
            isValid = false;
            props.addError("signagePanels", "# Panels with Signs is required!");
        }

        return isValid;
    }

    const isFullBoundry = props.fenceQuestions.fenceAreas.find(f => f.id === 1)?.selected;
    const pricelistItem = <NewJobPricelistItemData isJobEvent={props.isJobEvent} jobTypeId={props.jobTypeId} schedulePickup={props.schedulePickup}
        lunchRoomExtraId={0} siteOfficeExtraId={0} showLocation={false} showExtras={true} showCleaning={false} showBracing={true} showMaintenance={false} showTruck={false} showEpaItems={false} showAdditionalHire={true}
        customerPickup={-1} allowAllocateToPastDate={props.allowAllocateToPastDate} jobInstalled={props.jobInstalled} accountTypeId={props.accountTypeId} quoteItems={props.quoteItems} itemOptions={props.itemOptions}
        truckHireRate={props.truckHireRate} fenceQuestions={props.fenceQuestions} frequencyOptions={[]} extraItemOptions={[]} yesNoOptions={[]} truckOptions={[]} truckSideOptions={[]}
        chargeFuelSurchargeSwitchedOn={props.chargeFuelSurchargeSwitchedOn} customerNewFuelInvoice={props.customerNewFuelInvoice} customerChargeFuelSurcharge={props.customerChargeFuelSurcharge}
        addItem={props.addItem} deleteItem={props.deleteItem} updateQuoteItem={props.updateQuoteItem} />

    return (
        <div>
            <div className="makeitflex">
                <div className="newJobFenceQuestions">
                    <div className="marginLeftLabelLarge makeitorange">Note: changing below will re-calculate any existing Fencing and Braced Items</div>
                    <label className="input-group marginBottom10" htmlFor="fenceTotalMetres">
                        <span className="label label-large">Total Fence Metres</span>
                        <input className="input textalignright" type="number" id="fenceTotalMetres" name="fenceTotalMetres" value={props.fenceQuestions.fenceTotalMetres} onChange={(e) => handleTotalMetresChange(e)}></input>
                    </label>
                    <span className={props.errors["fenceTotalMetres"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["fenceTotalMetres"]}</span>

                    <label className="input-group" htmlFor="treeProtection">
                        <span className="label label-large">Is tree protection required?</span> 
                        <input className="checkbox" type="checkbox" name="treeProtection" checked={props.fenceQuestions.treeProtection} onChange={(e) => handleFenceQuestionsChange(e)} ></input>
                    </label>
                    <span className={props.fenceQuestions.treeProtection ? "marginLeftLabelLarge makeitorange" : "hidden" }>Confirm that extra lm per tree has been included in Total Fence Metres.</span>

                    <label className="input-group" htmlFor="highWindArea">
                        <span className="label label-large">Is the site in a high wind area?</span>
                        <input className="checkbox" type="checkbox" name="highWindArea" checked={props.fenceQuestions.highWindArea} onChange={(e) => handleFenceQuestionsChange(e)} ></input>
                    </label>

                    <label className="input-group" htmlFor="shadeClothAdded">
                        <span className="label label-large">Will shade cloth (ours or theirs) be used?</span>
                        <input className="checkbox" type="checkbox" name="shadeClothAdded" checked={props.fenceQuestions.shadeClothAdded} onChange={(e) => handleFenceQuestionsChange(e)} ></input>
                    </label>

                    <label className="input-group" htmlFor="signageAdded">
                        <span className="label label-large">Will signs be added to any fence panels?</span>
                        <input className="checkbox" type="checkbox" name="signageAdded" checked={props.fenceQuestions.signageAdded} onChange={(e) => handleFenceQuestionsChange(e)} ></input>
                    </label>

                    <div className={props.fenceQuestions.signageAdded ? "" : "hidden" }>
                        <label className="input-group" htmlFor="signagePanels">
                            <span className="label label-large">Enter # Panels Signs will added to</span>
                            <input className="input customer__invDays" type="number" min="0" step="1" id="signagePanels" name="signagePanels" value={props.fenceQuestions.signagePanels} onChange={(e) => handleFenceQuestionsPanelsChange(e)}></input>
                        </label>
                        <span className={props.errors["signagePanels"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["signagePanels"]}</span>
                    </div>

                    <div className={(props.fenceQuestions.highWindArea || props.fenceQuestions.shadeClothAdded) ? "makeitorange makeitbold marginLeftLabelLarge marginBottom10" : "hidden"}>
                        Bracing recommended for every {props.fenceQuestions.highWindArea && props.fenceQuestions.shadeClothAdded ? "panel"
                            : !props.fenceQuestions.highWindArea && props.fenceQuestions.shadeClothAdded ? "2nd panel"
                                : props.fenceQuestions.highWindArea && !props.fenceQuestions.shadeClothAdded ? "3rd panel" : ""}
                        {props.fenceQuestions.signageAdded ? " and to the " + (props.fenceQuestions.signagePanels > 0 ? props.fenceQuestions.signagePanels : "") + " panels with signs added" : ""}
                    </div>
                    <div className={!props.fenceQuestions.highWindArea && !props.fenceQuestions.shadeClothAdded && props.fenceQuestions.signageAdded ? "makeitorange makeitbold marginLeftLabelLarge marginBottom10" : "hidden"}>
                        Bracing recommended for the {props.fenceQuestions.signagePanels > 0 ? props.fenceQuestions.signagePanels : ""} panels with Signs added.
                    </div>
                    <button className="defaultbutton marginLeftLabelLarge marginBottom10" onClick={addFenceItems} type="button">Add Fence Items</button>
                </div>
                <div>
                    <label className="input-group" htmlFor="fenceArea">
                        <span className="label label-large">Select Fence Area/s</span>
                        <div>
                            {props.fenceQuestions.fenceAreas.map((item, index) =>
                                <span key={item.id} className="newJobFenceAreaContainer">
                                    <input className="checkbox" type="checkbox" id={"fenceArea" + index} name={"fenceArea" + index} checked={item.selected} onChange={(e) => handleAreaChange(e, index)} disabled={isFullBoundry && item.id > 1}></input>
                                    <label className="label marginLeft20" htmlFor={"fenceArea" + index}>{item.name}</label>
                                </span>
                            )}
                        </div>
                    </label>
                      
                    <span className={props.errors["fenceArea"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["fenceArea"]}</span>
                </div>
            </div>
            <div className="newJobPricelist--customer-notes">{props.customerQuoteNotesDunny}</div>

            {pricelistItem}

            {props.errors["fencingQuoteItems"] ?
                (props.errors["fencingQuoteItems"]).split("\n").map((item: any, key: any) => {
                    return <span className="label errors" key={key}>{item}<br /></span>
                })
                : ""}
                
        </div>
    )

}

export default NewJobPricelistFencingData;